/******************************************************************************
 *** BgtEvdncDialog ** 운영비 지출증빙내역서 모달(조회용)
*******************************************************************************/
import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import TextBox from "@/js/common/ui/input/TextBox";
import NumberTextBox from "@/js/common/ui/input/NumberTextBox";
import Util from "@/js/common/Util";
import BudgetViewFile from "../../budgetFileBox/BudgetViewFile";
import { budgetFilesProps } from "@/js/common/types/types";

interface Props {
  expndEvdncId: string; // 지출증빙내역서 ID
}

const BgtEvdncDialog = ({expndEvdncId}: Props) => {
    const [useDt    , setUseDt    ] = React.useState<string>(""); // 사용일자
    const [usePrpsCn, setUsePrpsCn] = React.useState<string>(""); // 사용목적내용
    const [useCn    , setUseCn    ] = React.useState<string>(""); // 사용내용
    const [useAmt   , setUseAmt   ] = React.useState<string>(""); // 사용금액
    const [etcCn    , setEtcCn    ] = React.useState<string>(""); // 기타내용
    const [rmrkCn   , setRmrkCn   ] = React.useState<string>(""); // 비고내용

    const [savedEvdncFiles, setSavedEvdncFiles] = React.useState<budgetFilesProps[]>([]); // 저장된 파일

    // 특별회계기금 지출증빙내역서 상세정보 조회
    React.useEffect(() => {
        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/mbsds/expnd/select-bgt-evdnc.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                expndEvdncId: expndEvdncId  // 지출증빙내역서 ID
            },
            onSuccessFn: (res: any) => {
                if (Util.isNotEmpty(res.result.item)) {
                    setUseDt    (res.result.item.useDt    ); // 사용일자
                    setUsePrpsCn(res.result.item.usePrpsCn); // 사용목적내용
                    setUseCn    (res.result.item.useCn    ); // 사용내용
                    setUseAmt   (res.result.item.useAmt   ); // 사용금액
                    setEtcCn    (res.result.item.etcCn    ); // 기타내용
                    setRmrkCn   (res.result.item.rmrkCn   ); // 비고내용

                    setSavedEvdncFiles(res.result.listFile); // 첨부파일
                }
                AppContext.hideSpinner();
            },
        });
    }, [expndEvdncId]);

    return (
        <div className="pb10 pl10 pr10">
            <div className="dpFlx gap20">
                {/* 사용일자 */}
                <div className="w210">
                    <div className="h30 dpFlx aiE pb5 bdBox">
                        <span className="fm-b fs13 ls06 fc111111">사용일자</span>
                    </div>
                    <DatePickerBox value={useDt}
                        width={210} height={36}
                        fontSize={13} fontFamily="fm-c" color="#222" letterSpacing={-0.5 as any}
                        borderColor="#cfcfcf" borderOnColor="#222" borderRadius={5}
                        bgColor="#F6F6F6" textAlign="left"
                        calendarThemeColor={AppContext.themeColor}
                        onChange={(data: string) => setUseDt(data)}
                        disabled={true}
                    />
                </div>
                <div className="w210 ml12">
                    <div className="h30 dpFlx aiE pb5 bdBox">
                        <span className="fm-b fs13 ls06 fc111111">집행 예정 금액</span>
                    </div>
                    <div className="h36 dpFlx aiC bd1 bdrd5 bdcCFCFCF bgcFFE6CE bsBdb">
                        <NumberTextBox value={useAmt}
                            className="w100p h100p ml10 taR"
                            thousandsGroupStyle="thousand" thousandSeparator=","
                            placeholder="0"
                            fontSize={13} fontFamily="fm-c" letterSpacing={-0.5} color="#222"
                            inputClass={"taR mr10"}
                            disabled={true}
                            onChange={(v: string) => setUseAmt(v)}
                        />
                    </div>
                </div>
            </div>

            {/* 사용목적 */}
            <div className="w100p">
                <div className="h30 dpFlx aiE pb5 bdBox">
                    <span className="fm-b fs13 ls06 fc111111">사용목적</span>
                </div>
                <TextBox  value={usePrpsCn}
                    width={454} height={36}
                    fontSize={13} fontFamily="fm-c" color="#222" letterSpacing={-0.5}
                    borderColor="#cfcfcf" borderOnColor="#222" borderRadius={5}
                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                    onChangeFunc={(text: string) => setUsePrpsCn(text)}
                    mode={"disabled"}
                />
            </div>

            {/* 사용내용 */}
            <div className="mt10">
                <div className="h30 dpFlx aiE pb5 bdBox">
                    <span className="fm-b fs13 ls06 fc111111">내용</span>
                </div>
                <div className="flxg1 bsBdb">
                    <textarea value={useCn}
                        className="w100p h100 bsBdb p10 bdrd5 bd1 bdcDFDFDF bdrd2 fm-c fs13 fc333333 ls1 lh20 bgcF6F6F6 rszN"
                        maxLength={2000}
                        placeholder=""
                        onChange={(e) => setUseCn(e.target.value)}
                        disabled={true}
                    />
                </div>
            </div>

            {/* 기타내용 */}
            <div className="">
                <div className="h30 dpFlx aiE pb5 bdBox">
                    <span className="fm-b fs13 ls06 fc111111">기타 내용</span>
                </div>
                <div className="flxg1 bsBdb">
                    <textarea value={etcCn}
                        className="w100p h50 bsBdb p10 bdrd5 bd1 bdcDFDFDF bdrd5 fm-c fs13 fc333333 ls1 lh20 bgcF6F6F6 rszN"
                        maxLength={2000}
                        placeholder=""
                        onChange={(e) => setEtcCn(e.target.value)}
                        disabled={true}
                    />
                </div>
            </div>
            {/* 비고 */}
            <div className="mt10">
                <div className="h30 dpFlx aiE pb5 bdBox">
                    <span className="fm-b fs13 ls06 fc111111">비고</span>
                </div>
                <div className="flxg1 bsBdb">
                    <textarea
                        value={rmrkCn}
                        className="w100p h50 bsBdb p10 bdrd5 bd1 bdcDFDFDF bdrd2 fm-c fs13 fc333333 ls1 lh20 bgcF6F6F6 rszN"
                        maxLength={2000}
                        placeholder=""
                        onChange={(e) => setRmrkCn(e.target.value)}
                        disabled={true}
                    />
                </div>
            </div>

            {/* 첨부파일(수입과 동일 컴포넌트 사용) */}
            <BudgetViewFile
                fileSeCd         = "A03"   // 파일구분코드(운영비_지출증빙내역서[A03])
                savedBudgetFiles = {savedEvdncFiles}
                width = "450px"
                height = "70px"
            />
        </div>
    )
};

export default BgtEvdncDialog;
